// Status da entrega exibido no resultado e nas buscas recentes.
//
// O STATUS vem da API (`status`, `statusLabel`, `semRetorno`, `atrasoNaEntrega`),
// calculado pela regra canônica do backend (deliveryStatusSql.js, PO1-2820),
// a mesma de Entregas Pendentes, Pedidos e KPI. A tela não deriva status de
// data: só escolhe o tom e escreve a frase do que falta. As datas (dd/mm/aaaa)
// entram apenas no texto.

export const hasDate = (value) => Boolean(value && value !== "-");

const DESCRICOES = {
  devolvida: () => "A transportadora registrou a devolução desta nota.",
  atrasada: (item) =>
    `A previsão era ${item.dt_previsao_entrega || "-"} e a entrega ainda não foi confirmada.${
      item.semRetorno ? " A transportadora não registrou nenhuma ocorrência." : ""
    }`,
  em_transito: (item) => `Previsão de entrega em ${item.dt_previsao_entrega || "-"}.`,
  pendente: (item) =>
    `Previsão de entrega em ${item.dt_previsao_entrega || "-"}. A transportadora ainda não registrou ocorrência.`,
  sem_previsao: (item) =>
    hasDate(item.dt_emissao)
      ? `Nota emitida em ${item.dt_emissao}. A transportadora ainda não informou a previsão de entrega.`
      : "A transportadora ainda não informou a previsão de entrega.",
  // PO1-3401: sem transportadora que mande rastreio.
  retirada: () => "O próprio destinatário retirou a mercadoria (consta como transportador na nota).",
  entrega_propria: () =>
    "Entrega feita pela própria empresa, sem transportadora contratada. A confirmação vem pela baixa da entrega.",
  // PO1-2374 (H1-B): estados pré-entrega do lote de despacho / envio. A carga
  // ainda está com o embarcador até a transportadora registrar a 1ª ocorrência.
  etiqueta_emitida: () => "Etiqueta emitida. A transportadora ainda não confirmou o recebimento da carga.",
  despachado: () => "Lote despachado. A transportadora ainda não confirmou o recebimento da carga.",
};

const TONS = {
  entregue: "success",
  devolvida: "danger",
  atrasada: "danger",
  em_transito: "info",
  pendente: "neutral",
  sem_previsao: "neutral",
  retirada: "success",
  entrega_propria: "info",
  etiqueta_emitida: "neutral", // como "em preparação"
  despachado: "info", // como "a caminho"
};

export const getDeliveryStatus = (item) => {
  const status = item.status || "nao_encontrada";
  const label = item.statusLabel || "Não encontrada";

  if (status === "entregue") {
    const quando = item.dt_entrega ? `Entrega realizada em ${item.dt_entrega}` : "Entrega realizada";
    // `atrasoNaEntrega` também vem da API: null = entregue sem previsão.
    if (item.atrasoNaEntrega === true) {
      return {
        tone: "warning",
        label: "Entregue com atraso",
        description: `${quando}, após a previsão de ${item.dt_previsao_entrega || "-"}.`,
      };
    }
    if (item.atrasoNaEntrega === false) {
      return {
        tone: "success",
        label: "Entregue no prazo",
        description: `${quando}, dentro da previsão de ${item.dt_previsao_entrega || "-"}.`,
      };
    }
    return { tone: "success", label, description: `${quando}.` };
  }

  return {
    tone: TONS[status] || "neutral",
    label: status === "atrasada" && item.semRetorno ? "Atrasada · sem retorno" : label,
    description: DESCRICOES[status] ? DESCRICOES[status](item) : "Não encontramos o status desta entrega.",
  };
};

export const buildSteps = (item) => [
  { key: "emissao", label: "Emissão", date: item.dt_emissao },
  { key: "previsao", label: "Previsão", date: item.dt_previsao_entrega },
  { key: "entrega", label: "Entrega", date: item.dt_entrega },
];

/** % da barra entre o 1º e o último passo (0, 50 ou 100). */
export const getTimelineProgress = (steps) => {
  const completed = steps.filter((step) => hasDate(step.date)).length;
  if (completed <= 1) return 0;
  return ((completed - 1) / (steps.length - 1)) * 100;
};

export const rotuloCidade = (cidade, uf) => {
  if (!cidade) return null;
  return uf ? `${cidade}/${uf}` : cidade;
};

